import notificationsTopics from "./notificationsTopic";

export default [notificationsTopics.ACTIVATION_NEW, notificationsTopics.EBOOK_NEW, notificationsTopics.INDEX_NEW];
